/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import type { PlaniraTemplate } from "../types";
import { FlowAdventureParkVisitTemplate } from "./flows/FlowAdventureParkVisitTemplate";
import { FlowArtExhibitionTemplate } from "./flows/FlowArtExhibitionTemplate";
import { FlowArtFestivalTemplate } from "./flows/FlowArtFestivalTemplate";
import { FlowArtWorkshopTemplate } from "./flows/FlowArtWorkshopTemplate";
import { FlowBakingClassTemplate } from "./flows/FlowBakingClassTemplate";
import { FlowBakingCompetitionTemplate } from "./flows/FlowBakingCompetitionTemplate";
import { FlowBakingWithKidsTemplate } from "./flows/FlowBakingWithKidsTemplate";
import { FlowBarbecuePartyTemplate } from "./flows/FlowBarbecuePartyTemplate";
import { FlowBeachDayTemplate } from "./flows/FlowBeachDayTemplate";
import { FlowBoardGameCafeVisitTemplate } from "./flows/FlowBoardGameCafeVisitTemplate";
import { FlowBoardGameNightTemplate } from "./flows/FlowBoardGameNightTemplate";
import { FlowBoardGameTournamentTemplate } from "./flows/FlowBoardGameTournamentTemplate";
import { FlowBookClubTemplate } from "./flows/FlowBookClubTemplate";
import { FlowBookExchangeTemplate } from "./flows/FlowBookExchangeTemplate";
import { FlowBookbindingWorkshopTemplate } from "./flows/FlowBookbindingWorkshopTemplate";
import { FlowBreweryTourTemplate } from "./flows/FlowBreweryTourTemplate";
import { FlowCampingTripTemplate } from "./flows/FlowCampingTripTemplate";
import { FlowCharityRunTemplate } from "./flows/FlowCharityRunTemplate";
import { FlowCodingBootcampTemplate } from "./flows/FlowCodingBootcampTemplate";
import { FlowCoffeeTastingTemplate } from "./flows/FlowCoffeeTastingTemplate";
import { FlowConcertNightTemplate } from "./flows/FlowConcertNightTemplate";
import { FlowCookingChallengeTemplate } from "./flows/FlowCookingChallengeTemplate";
import { FlowCookingClassTemplate } from "./flows/FlowCookingClassTemplate";
import { FlowCookingCompetitionTemplate } from "./flows/FlowCookingCompetitionTemplate";
import { FlowCookingForACauseTemplate } from "./flows/FlowCookingForACauseTemplate";
import { FlowCookingWithKidsTemplate } from "./flows/FlowCookingWithKidsTemplate";
import { FlowCraftBeerBreweryTourTemplate } from "./flows/FlowCraftBeerBreweryTourTemplate";
import { FlowCraftWorkshopTemplate } from "./flows/FlowCraftWorkshopTemplate";
import { FlowCulinaryClassTemplate } from "./flows/FlowCulinaryClassTemplate";
import { FlowCulturalExperienceTemplate } from "./flows/FlowCulturalExperienceTemplate";
import { FlowCulturalFestivalTemplate } from "./flows/FlowCulturalFestivalTemplate";
import { FlowDIYProjectTemplate } from "./flows/FlowDIYProjectTemplate";
import { FlowDancePartyTemplate } from "./flows/FlowDancePartyTemplate";
import { FlowDinnerPartyTemplate } from "./flows/FlowDinnerPartyTemplate";
import { FlowEatOutTemplate } from "./flows/FlowEatOutTemplate";
import { FlowEscapeRoomTemplate } from "./flows/FlowEscapeRoomTemplate";
import { FlowFamilyArtDayTemplate } from "./flows/FlowFamilyArtDayTemplate";
import { FlowFamilyGameDayTemplate } from "./flows/FlowFamilyGameDayTemplate";
import { FlowFamilyGameNightTemplate } from "./flows/FlowFamilyGameNightTemplate";
import { FlowFamilyHealthDayTemplate } from "./flows/FlowFamilyHealthDayTemplate";
import { FlowFamilyMovieNightTemplate } from "./flows/FlowFamilyMovieNightTemplate";
import { FlowFamilySportsDayTemplate } from "./flows/FlowFamilySportsDayTemplate";
import { FlowFamilyWellnessRetreatTemplate } from "./flows/FlowFamilyWellnessRetreatTemplate";
import { FlowFarmersMarketTemplate } from "./flows/FlowFarmersMarketTemplate";
import { FlowFashionDesignWorkshopTemplate } from "./flows/FlowFashionDesignWorkshopTemplate";
import { FlowFashionShowTemplate } from "./flows/FlowFashionShowTemplate";
import { FlowFestivalTripTemplate } from "./flows/FlowFestivalTripTemplate";
import { FlowFitnessChallengeTemplate } from "./flows/FlowFitnessChallengeTemplate";
import { FlowFitnessRetreatTemplate } from "./flows/FlowFitnessRetreatTemplate";
import { FlowFitnessWorkshopTemplate } from "./flows/FlowFitnessWorkshopTemplate";
import { FlowFoodTruckEventTemplate } from "./flows/FlowFoodTruckEventTemplate";
import { FlowFunRunEventTemplate } from "./flows/FlowFunRunEventTemplate";
import { FlowGameDevelopmentWorkshopTemplate } from "./flows/FlowGameDevelopmentWorkshopTemplate";
import { FlowGameShowNightTemplate } from "./flows/FlowGameShowNightTemplate";
import { FlowGameShowTemplate } from "./flows/FlowGameShowTemplate";
import { FlowGardenPartyTemplate } from "./flows/FlowGardenPartyTemplate";
import { FlowGroupCookingNightTemplate } from "./flows/FlowGroupCookingNightTemplate";
import { FlowGroupFitnessChallengeTemplate } from "./flows/FlowGroupFitnessChallengeTemplate";
import { FlowGroupMeditationDayTemplate } from "./flows/FlowGroupMeditationDayTemplate";
import { FlowGroupMeditationTemplate } from "./flows/FlowGroupMeditationTemplate";
import { FlowHerbalWorkshopTemplate } from "./flows/FlowHerbalWorkshopTemplate";
import { FlowHikingTripTemplate } from "./flows/FlowHikingTripTemplate";
import { FlowHolidayPartyTemplate } from "./flows/FlowHolidayPartyTemplate";
import { FlowHomeImprovementProjectTemplate } from "./flows/FlowHomeImprovementProjectTemplate";
import { FlowIceCreamSocialTemplate } from "./flows/FlowIceCreamSocialTemplate";
import { FlowIceSkatingTemplate } from "./flows/FlowIceSkatingTemplate";
import { FlowKaraokeNightTemplate } from "./flows/FlowKaraokeNightTemplate";
import { FlowLanguageExchangeTemplate } from "./flows/FlowLanguageExchangeTemplate";
import { FlowMindfulnessWorkshopTemplate } from "./flows/FlowMindfulnessWorkshopTemplate";
import { FlowMovieMarathonTemplate } from "./flows/FlowMovieMarathonTemplate";
import { FlowMuralPaintingWorkshopTemplate } from "./flows/FlowMuralPaintingWorkshopTemplate";
import { FlowMurderMysteryPartyTemplate } from "./flows/FlowMurderMysteryPartyTemplate";
import { FlowMusicFestivalTemplate } from "./flows/FlowMusicFestivalTemplate";
import { FlowMusicNightTemplate } from "./flows/FlowMusicNightTemplate";
import { FlowMusicProductionWorkshopTemplate } from "./flows/FlowMusicProductionWorkshopTemplate";
import { FlowNatureExplorationTemplate } from "./flows/FlowNatureExplorationTemplate";
import { FlowNaturePhotographyTemplate } from "./flows/FlowNaturePhotographyTemplate";
import { FlowNatureWalkTemplate } from "./flows/FlowNatureWalkTemplate";
import { FlowNetworkingEventTemplate } from "./flows/FlowNetworkingEventTemplate";
import { FlowOutdoorAdventureRetreatTemplate } from "./flows/FlowOutdoorAdventureRetreatTemplate";
import { FlowOutdoorAdventureTemplate } from "./flows/FlowOutdoorAdventureTemplate";
import { FlowOutdoorFamilyDayTemplate } from "./flows/FlowOutdoorFamilyDayTemplate";
import { FlowOutdoorFitnessChallengeTemplate } from "./flows/FlowOutdoorFitnessChallengeTemplate";
import { FlowOutdoorHikingTripTemplate } from "./flows/FlowOutdoorHikingTripTemplate";
import { FlowOutdoorMovieNightTemplate } from "./flows/FlowOutdoorMovieNightTemplate";
import { FlowOutdoorPaintingDayTemplate } from "./flows/FlowOutdoorPaintingDayTemplate";
import { FlowOutdoorPicnicTemplate } from "./flows/FlowOutdoorPicnicTemplate";
import { FlowOutdoorSportsDayTemplate } from "./flows/FlowOutdoorSportsDayTemplate";
import { FlowOutdoorWellnessDayTemplate } from "./flows/FlowOutdoorWellnessDayTemplate";
import { FlowOutdoorYogaSessionTemplate } from "./flows/FlowOutdoorYogaSessionTemplate";
import { FlowPaintNightTemplate } from "./flows/FlowPaintNightTemplate";
import { FlowPaintballGameTemplate } from "./flows/FlowPaintballGameTemplate";
import { FlowPersonalFinanceWorkshopTemplate } from "./flows/FlowPersonalFinanceWorkshopTemplate";
import { FlowPetAdoptionEventTemplate } from "./flows/FlowPetAdoptionEventTemplate";
import { FlowPhotographyExhibitionTemplate } from "./flows/FlowPhotographyExhibitionTemplate";
import { FlowPhotographyWorkshopTemplate } from "./flows/FlowPhotographyWorkshopTemplate";
import { FlowPicnicTemplate } from "./flows/FlowPicnicTemplate";
import { FlowPotluckDinnerTemplate } from "./flows/FlowPotluckDinnerTemplate";
import { FlowPotluckPicnicTemplate } from "./flows/FlowPotluckPicnicTemplate";
import { FlowPotluckTemplate } from "./flows/FlowPotluckTemplate";
import { FlowPotteryClassTemplate } from "./flows/FlowPotteryClassTemplate";
import { FlowPotteryPaintingWorkshopTemplate } from "./flows/FlowPotteryPaintingWorkshopTemplate";
import { FlowPotteryWorkshopTemplate } from "./flows/FlowPotteryWorkshopTemplate";
import { FlowQuiltingWorkshopTemplate } from "./flows/FlowQuiltingWorkshopTemplate";
import { FlowRoadTripTemplate } from "./flows/FlowRoadTripTemplate";
import { FlowRockClimbingAdventureTemplate } from "./flows/FlowRockClimbingAdventureTemplate";
import { FlowScavengerHuntTemplate } from "./flows/FlowScavengerHuntTemplate";
import { FlowSculptureWorkshopTemplate } from "./flows/FlowSculptureWorkshopTemplate";
import { FlowSelfCareWorkshopTemplate } from "./flows/FlowSelfCareWorkshopTemplate";
import { FlowSewingWorkshopTemplate } from "./flows/FlowSewingWorkshopTemplate";
import { FlowSkiTripTemplate } from "./flows/FlowSkiTripTemplate";
import { FlowSocialGatheringTemplate } from "./flows/FlowSocialGatheringTemplate";
import { FlowSocialMediaMarketingWorkshopTemplate } from "./flows/FlowSocialMediaMarketingWorkshopTemplate";
import { FlowSpaDayTemplate } from "./flows/FlowSpaDayTemplate";
import { FlowSportsGameTemplate } from "./flows/FlowSportsGameTemplate";
import { FlowStorytellingNightTemplate } from "./flows/FlowStorytellingNightTemplate";
import { FlowSummerCampTemplate } from "./flows/FlowSummerCampTemplate";
import { FlowSustainableLivingWorkshopTemplate } from "./flows/FlowSustainableLivingWorkshopTemplate";
import { FlowTechTalkTemplate } from "./flows/FlowTechTalkTemplate";
import { FlowTravelPlanTemplate } from "./flows/FlowTravelPlanTemplate";
import { FlowTravelTemplate } from "./flows/FlowTravelTemplate";
import { FlowTriviaGameTemplate } from "./flows/FlowTriviaGameTemplate";
import { FlowTriviaNightExtendedTemplate } from "./flows/FlowTriviaNightExtendedTemplate";
import { FlowVideoEditingWorkshopTemplate } from "./flows/FlowVideoEditingWorkshopTemplate";
import { FlowVirtualCulturalFestivalTemplate } from "./flows/FlowVirtualCulturalFestivalTemplate";
import { FlowVirtualGameNightTemplate } from "./flows/FlowVirtualGameNightTemplate";
import { FlowVirtualRealityExperienceTemplate } from "./flows/FlowVirtualRealityExperienceTemplate";
import { FlowVirtualWorkshopTemplate } from "./flows/FlowVirtualWorkshopTemplate";
import { FlowWeekendAdventureTemplate } from "./flows/FlowWeekendAdventureTemplate";
import { FlowWeekendGetawayTemplate } from "./flows/FlowWeekendGetawayTemplate";
import { FlowWeekendRetreatTemplate } from "./flows/FlowWeekendRetreatTemplate";
import { FlowWellnessRetreatTemplate } from "./flows/FlowWellnessRetreatTemplate";
import { FlowWineAndPaintNightTemplate } from "./flows/FlowWineAndPaintNightTemplate";
import { FlowWineTastingTemplate } from "./flows/FlowWineTastingTemplate";
import { FlowYogaClassTemplate } from "./flows/FlowYogaClassTemplate";
import { FlowYogaRetreatTemplate } from "./flows/FlowYogaRetreatTemplate";
import { PlanTemplateType } from "./template_types";

export const availablePlanFlowTemplates: {
  [key in PlanTemplateType]?: PlaniraTemplate;
} = {
  [PlanTemplateType.FlowAdventureParkVisit]: FlowAdventureParkVisitTemplate,
  [PlanTemplateType.FlowArtExhibition]: FlowArtExhibitionTemplate,
  [PlanTemplateType.FlowArtFestival]: FlowArtFestivalTemplate,
  [PlanTemplateType.FlowArtWorkshop]: FlowArtWorkshopTemplate,
  [PlanTemplateType.FlowBakingClass]: FlowBakingClassTemplate,
  [PlanTemplateType.FlowBakingCompetition]: FlowBakingCompetitionTemplate,
  [PlanTemplateType.FlowBakingWithKids]: FlowBakingWithKidsTemplate,
  [PlanTemplateType.FlowBarbecueParty]: FlowBarbecuePartyTemplate,
  [PlanTemplateType.FlowBeachDay]: FlowBeachDayTemplate,
  [PlanTemplateType.FlowBoardGameCafeVisit]: FlowBoardGameCafeVisitTemplate,
  [PlanTemplateType.FlowBoardGameNight]: FlowBoardGameNightTemplate,
  [PlanTemplateType.FlowBoardGameTournament]: FlowBoardGameTournamentTemplate,
  [PlanTemplateType.FlowBookClub]: FlowBookClubTemplate,
  [PlanTemplateType.FlowBookExchange]: FlowBookExchangeTemplate,
  [PlanTemplateType.FlowBookbindingWorkshop]: FlowBookbindingWorkshopTemplate,
  [PlanTemplateType.FlowBreweryTour]: FlowBreweryTourTemplate,
  [PlanTemplateType.FlowCampingTrip]: FlowCampingTripTemplate,
  [PlanTemplateType.FlowCharityRun]: FlowCharityRunTemplate,
  [PlanTemplateType.FlowCodingBootcamp]: FlowCodingBootcampTemplate,
  [PlanTemplateType.FlowCoffeeTasting]: FlowCoffeeTastingTemplate,
  [PlanTemplateType.FlowConcertNight]: FlowConcertNightTemplate,
  [PlanTemplateType.FlowCookingChallenge]: FlowCookingChallengeTemplate,
  [PlanTemplateType.FlowCookingClass]: FlowCookingClassTemplate,
  [PlanTemplateType.FlowCookingCompetition]: FlowCookingCompetitionTemplate,
  [PlanTemplateType.FlowCookingForACause]: FlowCookingForACauseTemplate,
  [PlanTemplateType.FlowCookingWithKids]: FlowCookingWithKidsTemplate,
  [PlanTemplateType.FlowCraftBeerBreweryTour]: FlowCraftBeerBreweryTourTemplate,
  [PlanTemplateType.FlowCraftWorkshop]: FlowCraftWorkshopTemplate,
  [PlanTemplateType.FlowCulinaryClass]: FlowCulinaryClassTemplate,
  [PlanTemplateType.FlowCulturalExperience]: FlowCulturalExperienceTemplate,
  [PlanTemplateType.FlowCulturalFestival]: FlowCulturalFestivalTemplate,
  [PlanTemplateType.FlowDIYProject]: FlowDIYProjectTemplate,
  [PlanTemplateType.FlowDanceParty]: FlowDancePartyTemplate,
  [PlanTemplateType.FlowDinnerParty]: FlowDinnerPartyTemplate,
  [PlanTemplateType.FlowEatOut]: FlowEatOutTemplate,
  [PlanTemplateType.FlowEscapeRoom]: FlowEscapeRoomTemplate,
  [PlanTemplateType.FlowFamilyArtDay]: FlowFamilyArtDayTemplate,
  [PlanTemplateType.FlowFamilyGameDay]: FlowFamilyGameDayTemplate,
  [PlanTemplateType.FlowFamilyGameNight]: FlowFamilyGameNightTemplate,
  [PlanTemplateType.FlowFamilyHealthDay]: FlowFamilyHealthDayTemplate,
  [PlanTemplateType.FlowFamilyMovieNight]: FlowFamilyMovieNightTemplate,
  [PlanTemplateType.FlowFamilySportsDay]: FlowFamilySportsDayTemplate,
  [PlanTemplateType.FlowFamilyWellnessRetreat]:
    FlowFamilyWellnessRetreatTemplate,
  [PlanTemplateType.FlowFarmersMarket]: FlowFarmersMarketTemplate,
  [PlanTemplateType.FlowFashionDesignWorkshop]:
    FlowFashionDesignWorkshopTemplate,
  [PlanTemplateType.FlowFashionShow]: FlowFashionShowTemplate,
  [PlanTemplateType.FlowFestivalTrip]: FlowFestivalTripTemplate,
  [PlanTemplateType.FlowFitnessChallenge]: FlowFitnessChallengeTemplate,
  [PlanTemplateType.FlowFitnessRetreat]: FlowFitnessRetreatTemplate,
  [PlanTemplateType.FlowFitnessWorkshop]: FlowFitnessWorkshopTemplate,
  [PlanTemplateType.FlowFoodTruckEvent]: FlowFoodTruckEventTemplate,
  [PlanTemplateType.FlowFunRunEvent]: FlowFunRunEventTemplate,
  [PlanTemplateType.FlowGameDevelopmentWorkshop]:
    FlowGameDevelopmentWorkshopTemplate,
  [PlanTemplateType.FlowGameShow]: FlowGameShowTemplate,
  [PlanTemplateType.FlowGameShowNight]: FlowGameShowNightTemplate,
  [PlanTemplateType.FlowGardenParty]: FlowGardenPartyTemplate,
  [PlanTemplateType.FlowGroupCookingNight]: FlowGroupCookingNightTemplate,
  [PlanTemplateType.FlowGroupFitnessChallenge]:
    FlowGroupFitnessChallengeTemplate,
  [PlanTemplateType.FlowGroupMeditation]: FlowGroupMeditationTemplate,
  [PlanTemplateType.FlowGroupMeditationDay]: FlowGroupMeditationDayTemplate,
  [PlanTemplateType.FlowHerbalWorkshop]: FlowHerbalWorkshopTemplate,
  [PlanTemplateType.FlowHikingTrip]: FlowHikingTripTemplate,
  [PlanTemplateType.FlowHolidayParty]: FlowHolidayPartyTemplate,
  [PlanTemplateType.FlowHomeImprovementProject]:
    FlowHomeImprovementProjectTemplate,
  [PlanTemplateType.FlowIceCreamSocial]: FlowIceCreamSocialTemplate,
  [PlanTemplateType.FlowIceSkating]: FlowIceSkatingTemplate,
  [PlanTemplateType.FlowKaraokeNight]: FlowKaraokeNightTemplate,
  [PlanTemplateType.FlowLanguageExchange]: FlowLanguageExchangeTemplate,
  [PlanTemplateType.FlowMindfulnessWorkshop]: FlowMindfulnessWorkshopTemplate,
  [PlanTemplateType.FlowMovieMarathon]: FlowMovieMarathonTemplate,
  [PlanTemplateType.FlowMuralPaintingWorkshop]:
    FlowMuralPaintingWorkshopTemplate,
  [PlanTemplateType.FlowMurderMysteryParty]: FlowMurderMysteryPartyTemplate,
  [PlanTemplateType.FlowMusicFestival]: FlowMusicFestivalTemplate,
  [PlanTemplateType.FlowMusicNight]: FlowMusicNightTemplate,
  [PlanTemplateType.FlowMusicProductionWorkshop]:
    FlowMusicProductionWorkshopTemplate,
  [PlanTemplateType.FlowNatureExploration]: FlowNatureExplorationTemplate,
  [PlanTemplateType.FlowNaturePhotography]: FlowNaturePhotographyTemplate,
  [PlanTemplateType.FlowNatureWalk]: FlowNatureWalkTemplate,
  [PlanTemplateType.FlowNetworkingEvent]: FlowNetworkingEventTemplate,
  [PlanTemplateType.FlowOutdoorAdventure]: FlowOutdoorAdventureTemplate,
  [PlanTemplateType.FlowOutdoorAdventureRetreat]:
    FlowOutdoorAdventureRetreatTemplate,
  [PlanTemplateType.FlowOutdoorFamilyDay]: FlowOutdoorFamilyDayTemplate,
  [PlanTemplateType.FlowOutdoorFitnessChallenge]:
    FlowOutdoorFitnessChallengeTemplate,
  [PlanTemplateType.FlowOutdoorHikingTrip]: FlowOutdoorHikingTripTemplate,
  [PlanTemplateType.FlowOutdoorMovieNight]: FlowOutdoorMovieNightTemplate,
  [PlanTemplateType.FlowOutdoorPaintingDay]: FlowOutdoorPaintingDayTemplate,
  [PlanTemplateType.FlowOutdoorPicnic]: FlowOutdoorPicnicTemplate,
  [PlanTemplateType.FlowOutdoorSportsDay]: FlowOutdoorSportsDayTemplate,
  [PlanTemplateType.FlowOutdoorWellnessDay]: FlowOutdoorWellnessDayTemplate,
  [PlanTemplateType.FlowOutdoorYogaSession]: FlowOutdoorYogaSessionTemplate,
  [PlanTemplateType.FlowPaintNight]: FlowPaintNightTemplate,
  [PlanTemplateType.FlowPaintballGame]: FlowPaintballGameTemplate,
  [PlanTemplateType.FlowPersonalFinanceWorkshop]:
    FlowPersonalFinanceWorkshopTemplate,
  [PlanTemplateType.FlowPetAdoptionEvent]: FlowPetAdoptionEventTemplate,
  [PlanTemplateType.FlowPhotographyExhibition]:
    FlowPhotographyExhibitionTemplate,
  [PlanTemplateType.FlowPhotographyWorkshop]: FlowPhotographyWorkshopTemplate,
  [PlanTemplateType.FlowPicnic]: FlowPicnicTemplate,
  [PlanTemplateType.FlowPotluck]: FlowPotluckTemplate,
  [PlanTemplateType.FlowPotluckDinner]: FlowPotluckDinnerTemplate,
  [PlanTemplateType.FlowPotluckPicnic]: FlowPotluckPicnicTemplate,
  [PlanTemplateType.FlowPotteryClass]: FlowPotteryClassTemplate,
  [PlanTemplateType.FlowPotteryPaintingWorkshop]:
    FlowPotteryPaintingWorkshopTemplate,
  [PlanTemplateType.FlowPotteryWorkshop]: FlowPotteryWorkshopTemplate,
  [PlanTemplateType.FlowQuiltingWorkshop]: FlowQuiltingWorkshopTemplate,
  [PlanTemplateType.FlowRoadTrip]: FlowRoadTripTemplate,
  [PlanTemplateType.FlowRockClimbingAdventure]:
    FlowRockClimbingAdventureTemplate,
  [PlanTemplateType.FlowScavengerHunt]: FlowScavengerHuntTemplate,
  [PlanTemplateType.FlowSculptureWorkshop]: FlowSculptureWorkshopTemplate,
  [PlanTemplateType.FlowSelfCareWorkshop]: FlowSelfCareWorkshopTemplate,
  [PlanTemplateType.FlowSewingWorkshop]: FlowSewingWorkshopTemplate,
  [PlanTemplateType.FlowSkiTrip]: FlowSkiTripTemplate,
  [PlanTemplateType.FlowSocialGathering]: FlowSocialGatheringTemplate,
  [PlanTemplateType.FlowSocialMediaMarketingWorkshop]:
    FlowSocialMediaMarketingWorkshopTemplate,
  [PlanTemplateType.FlowSpaDay]: FlowSpaDayTemplate,
  [PlanTemplateType.FlowSportsGame]: FlowSportsGameTemplate,
  [PlanTemplateType.FlowStorytellingNight]: FlowStorytellingNightTemplate,
  [PlanTemplateType.FlowSummerCamp]: FlowSummerCampTemplate,
  [PlanTemplateType.FlowSustainableLivingWorkshop]:
    FlowSustainableLivingWorkshopTemplate,
  [PlanTemplateType.FlowTechTalk]: FlowTechTalkTemplate,
  [PlanTemplateType.FlowTravel]: FlowTravelTemplate,
  [PlanTemplateType.FlowTravelPlan]: FlowTravelPlanTemplate,
  [PlanTemplateType.FlowTriviaGame]: FlowTriviaGameTemplate,
  [PlanTemplateType.FlowTriviaNightExtended]: FlowTriviaNightExtendedTemplate,
  [PlanTemplateType.FlowVideoEditingWorkshop]: FlowVideoEditingWorkshopTemplate,
  [PlanTemplateType.FlowVirtualCulturalFestival]:
    FlowVirtualCulturalFestivalTemplate,
  [PlanTemplateType.FlowVirtualGameNight]: FlowVirtualGameNightTemplate,
  [PlanTemplateType.FlowVirtualRealityExperience]:
    FlowVirtualRealityExperienceTemplate,
  [PlanTemplateType.FlowVirtualWorkshop]: FlowVirtualWorkshopTemplate,
  [PlanTemplateType.FlowWeekendAdventure]: FlowWeekendAdventureTemplate,
  [PlanTemplateType.FlowWeekendGetaway]: FlowWeekendGetawayTemplate,
  [PlanTemplateType.FlowWeekendRetreat]: FlowWeekendRetreatTemplate,
  [PlanTemplateType.FlowWellnessRetreat]: FlowWellnessRetreatTemplate,
  [PlanTemplateType.FlowWineAndPaintNight]: FlowWineAndPaintNightTemplate,
  [PlanTemplateType.FlowWineTasting]: FlowWineTastingTemplate,
  [PlanTemplateType.FlowYogaClass]: FlowYogaClassTemplate,
  [PlanTemplateType.FlowYogaRetreat]: FlowYogaRetreatTemplate,
};
